import jwtDecode from 'jwt-decode';

// eslint-disable-next-line import/no-cycle
import { postJson } from './fetchOptions';
import { updateAuthInStorage } from './auth';
import { redirectClientToOmniIfNeeded } from './redirectOmni';

export const checkTokenExpiry = async (token?: string) => {
  if (!token) return null;

  const expirationTimestamp = (jwtDecode(token) as TypeAny).exp;
  const currentTimestamp = Date.now() / 1000;
  const timestampDiff = expirationTimestamp - currentTimestamp;

  const isExpiring = timestampDiff <= 300 && timestampDiff > 0; // 300 sec = 5 min
  let isExpired = timestampDiff <= 0; // 300 sec = 5 min

  if (isExpiring) {
    await postJson({
      url: '/api/refresh',
      body: { refresh: token }
    }).then((refreshData) => {
      const { token: newToken, user } = refreshData;

      if (newToken && user) {
        updateAuthInStorage({
          token: newToken,
          user
        });
        redirectClientToOmniIfNeeded(user);
      } else {
        isExpired = true;
      }
    });
  }

  return isExpired;
};
